import { Box } from '@mui/material';
import BaseTypography from 'components/typography/BaseTypography';
import { reusableStyles } from 'ui-blocks/ReusableStyles';
import React from 'react';
import { unlockNewConfig } from 'config/unlockNewConfig';
import BaseImage from 'components/image/BaseImage';
import { unlockNewStyles } from './unlockNewStyles';

export default function UnlockNewSection() {
	return (
		<Box
			id="unlock-new-section"
			sx={[reusableStyles.flexColWithGap(36), reusableStyles.flexCenter, { width: '100%' }]}
		>
			<BaseTypography variant="h2_zodiak" styles={{ color: 'colors.light3', textAlign: 'center' }}>
				Unlock New Possibilities with AI Characters
			</BaseTypography>

			<Box id="unlock-new-images-container" sx={[unlockNewStyles.imagesContainer]}>
				{unlockNewConfig.map((unlockNew) => (
					<Box key={`${unlockNew.id}-${unlockNew.title}`} sx={[unlockNewStyles.imageContainer]}>
						<BaseImage
							src={unlockNew.image}
							alt={unlockNew.title}
							style={unlockNewStyles.imageBaseStyle}
						/>

						<Box id="image-content" sx={[unlockNewStyles.imageContent]}>
							<BaseTypography
								variant="h3_zodiak"
								styles={{
									color: 'colors.light1',
								}}
							>
								{unlockNew.title}
							</BaseTypography>
							<BaseTypography
								variant="b1_regular"
								styles={{
									color: 'colors.light1',
									// TO DO
									fontSize: { xs: '12px', mobileUi: '10px', lg: '12px', xl: '14px' },
								}}
							>
								{unlockNew.description}
							</BaseTypography>
						</Box>
					</Box>
				))}
			</Box>
		</Box>
	);
}
